const DEFAULT_STATE = {
  currentMainMenuSelected: "",
  breadcrumb: "",
  breadcrumbMobile: "",
  filter: false,
  order: false,
  isNotFoundPage: false,
  isHideHeader: false,
  view: "grid",
  routeParams: {}
};

const globalModule = {
  namespaced: true,
  state() {
    return DEFAULT_STATE;
  },
  mutations: {
    setView(state, view) {
      state.view = view;
    },
    setRouteParams(state, params) {
      state.routeParams = params;
    },
    setCurrentMainMenu(state, {
      section,
      breadcrumb,
      breadcrumbMobile,
      filter,
      order = false,
    }) {
      state.currentMainMenuSelected = section;
      state.breadcrumb = breadcrumb;
      state.breadcrumbMobile = breadcrumbMobile;
      state.filter = filter;
      state.order = order;
    },
    setNotFoundPage(state, args) {
      const { status } = args;
      state.isNotFoundPage = status;
    },
    setIsHideHeader(state, isHideHeader) {
      state.isHideHeader = isHideHeader;
    }
  },
};

export default globalModule;
